import { render } from "./WorkerComponent.vue?vue&type=template&id=46448631"
import script from "./WorkerComponent.vue?vue&type=script&lang=js"
export * from "./WorkerComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\96keh\\Desktop\\dev\\liof\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__